/* WowStampa — template collezione
   I filtri sono quelli nativi di Shopify (Search & Discovery): il markup arriva
   già renderizzato da Liquid con gli URL di filtro. Qui vive il comportamento
   (accordion, "mostra altri", ricerca nel gruppo, drawer, toolbar, intro,
   selettore guidato) e l'aggiornamento in AJAX del listato: la sezione viene
   richiesta con ?section_id e sostituita sul posto, senza ricaricare la pagina
   (quindi senza preloader del tema). Senza fetch si torna al submit normale. */
(function(){
var root=document.querySelector('.wow-collection');if(!root)return;
var SID=root.getAttribute('data-section-id')||'';
var CAN_AJAX=!!(window.fetch&&window.DOMParser&&window.history&&history.pushState&&SID);
var isNarrow=function(){return window.innerWidth<1024};
var form=function(){return root.querySelector('[data-filters]')};
var drawerForm=function(){return document.getElementById('wow-filters-m')};

/* ---------- pannello filtri: accordion, mostra altri, ricerca ---------- */
root.addEventListener('click',function(e){
var t=e.target;

var head=t.closest('[data-toggle]');
if(head){
var g=head.closest('.fg');
var open=g.classList.toggle('open');
head.setAttribute('aria-expanded',String(open));
var gl=head.querySelector('i');
if(gl)gl.textContent=open?'−':'+';
return;
}

var more=t.closest('[data-more]');
if(more){
var box=more.closest('.fg');
box.classList.add('all');
more.remove();
return;
}

if(t.closest('[data-open-filters]')){document.getElementById('wow-fdrawer').classList.add('on');document.body.style.overflow='hidden';return}
if(t.closest('[data-close-filters]')){
document.getElementById('wow-fdrawer').classList.remove('on');
document.body.style.overflow='';
/* "Mostra X prodotti": riporta la vista all'inizio del listato */
if(isNarrow()&&t.closest('.fdrawer-f'))toGrid();
return;
}

/* link che cambiano la vista: chip, azzeramenti, paginazione */
var a=t.closest('a[href]');
if(a&&CAN_AJAX&&(a.classList.contains('chip')||a.classList.contains('chip-clear')||a.classList.contains('fclear')||a.closest('.fdrawer-f')||a.closest('.wow-pag')||a.closest('.wow-empty'))){
e.preventDefault();
apply(a.getAttribute('href'),!!a.closest('.wow-pag'));
}
});

/* ricerca dentro un gruppo con molti valori */
root.addEventListener('input',function(e){
var s=e.target.closest('[data-fsearch]');if(!s)return;
var q=s.value.toLowerCase().trim(),g=s.closest('.fg');
g.classList.add('all');
g.querySelectorAll('.fopt').forEach(function(o){
o.classList.toggle('hid',!!q&&(o.dataset.label||'').indexOf(q)<0);
});
});

/* una selezione aggiorna il listato: in AJAX se possibile, altrimenti submit */
root.addEventListener('change',function(e){
var el=e.target;
if(!el.matches('input[type=checkbox],select'))return;
var f=el.form||form();if(!f)return;
if(!CAN_AJAX){if(f.requestSubmit)f.requestSubmit();else f.submit();return}
apply(urlOf(f),false);
});

/* il pulsante "Mostra N prodotti" ha già aggiornato tutto: chiude e basta */
root.addEventListener('submit',function(e){
var f=e.target;
if(!CAN_AJAX||(f.id!=='wow-filters'&&f.id!=='wow-filters-m'))return;
e.preventDefault();
if(f.id==='wow-filters-m'){
document.getElementById('wow-fdrawer').classList.remove('on');
document.body.style.overflow='';
if(isNarrow())toGrid();
}
});

function urlOf(f){
var p=new URLSearchParams();
new FormData(f).forEach(function(v,k){if(String(v).length)p.append(k,v)});
var q=p.toString();
return (f.getAttribute('action')||location.pathname)+(q?'?'+q:'');
}

function toGrid(){
var grid=document.getElementById('wow-grid');
if(grid)window.scrollTo({top:grid.getBoundingClientRect().top+window.pageYOffset-70,behavior:'smooth'});
}

/* ---------- aggiornamento in AJAX della sezione ---------- */
var ctl=null;
function apply(url,scroll){
if(!CAN_AJAX){location.href=url;return}
if(ctl&&ctl.abort)ctl.abort();
ctl=window.AbortController?new AbortController():null;
root.classList.add('busy');
root.setAttribute('aria-busy','true');
var open=[],dscroll=0;
root.querySelectorAll('.fg.open').forEach(function(g){open.push(g.getAttribute('data-fg'))});
var db=root.querySelector('.fdrawer-b');if(db)dscroll=db.scrollTop;
var sep=url.indexOf('?')>-1?'&':'?';
fetch(url+sep+'section_id='+encodeURIComponent(SID),{signal:ctl&&ctl.signal})
.then(function(r){if(!r.ok)throw 0;return r.text()})
.then(function(html){
var src=new DOMParser().parseFromString(html,'text/html').querySelector('.wow-collection');
if(!src)throw 0;
['.mfilters','.sidebar','.col-main','.fdrawer-b','.fdrawer-f'].forEach(function(sel){
var a=root.querySelector(sel),b=src.querySelector(sel);
if(a&&b)a.innerHTML=b.innerHTML;
});
open.forEach(function(id){
var g=root.querySelector('.fg[data-fg="'+id+'"]');if(!g)return;
g.classList.add('open');
var h=g.querySelector('[data-toggle]');if(h){h.setAttribute('aria-expanded','true');var i=h.querySelector('i');if(i)i.textContent='−'}
});
var nb=root.querySelector('.fdrawer-b');if(nb)nb.scrollTop=dscroll;
history.pushState({wow:1},'',url);
init();
if(scroll)toGrid();
})
.catch(function(err){if(err&&err.name==='AbortError')return;location.href=url})
.then(function(){root.classList.remove('busy');root.removeAttribute('aria-busy')});
}

window.addEventListener('popstate',function(){if(CAN_AJAX)apply(location.pathname+location.search,false)});

/* ---------- toolbar mobile: l'ordinamento si sposta accanto a Filtri ---------- */
function placeSort(){
var sw=root.querySelector('.sortwrap'),bar=root.querySelector('.mfilters'),res=root.querySelector('.res');
if(!sw||!bar||!res)return;
if(isNarrow()){var r=bar.querySelector('.mfilters-r');if(r&&!r.contains(sw))r.appendChild(sw)}
else if(!res.contains(sw))res.appendChild(sw);
}

/* ---------- intro: su mobile solo la prima frase ---------- */
var ledeT=root.querySelector('[data-lede]');
if(ledeT)ledeT.addEventListener('click',function(){
var p=root.querySelector('.lede'),open=p.classList.toggle('on');
ledeT.setAttribute('aria-expanded',String(open));
ledeT.textContent=open?ledeT.dataset.less||'Chiudi':ledeT.dataset.more||'Leggi tutto';
});

/* ---------- selettore guidato ---------- */
function fit(el,full){
el.textContent=full;
if(!el.clientHeight||el.scrollHeight<=el.clientHeight+1)return;
var w=full.split(' ');
while(w.length>3){w.pop();el.textContent=w.join(' ').replace(/[,.;:]$/,'')+'…';if(el.scrollHeight<=el.clientHeight+1)return}
}
function initSelector(){
var chipsBox=root.querySelector('.sel-chips');if(!chipsBox||chipsBox.dataset.ready)return;
var data=[];
try{data=JSON.parse((document.getElementById('wow-uses')||{}).textContent||'[]')}catch(err){}
if(!data.length)return;
var reco=root.querySelector('.reco');
function show(i,anim){
var u=data[i];if(!u)return;
var nm=root.querySelector('[data-reco-name]');if(nm)nm.textContent=u.name;
var rd=root.querySelector('[data-reco-desc]');
if(rd){rd.dataset.full=u.hint;fit(rd,u.hint);requestAnimationFrame(function(){fit(rd,u.hint)})}
var lk=root.querySelector('[data-reco-link]');if(lk)lk.href=u.url;
var im=reco&&reco.querySelector('img');
var set=function(){if(im&&u.img){im.src=u.img;im.alt=u.alt||u.name}};
if(anim&&reco){reco.classList.add('sw');setTimeout(function(){set();reco.classList.remove('sw')},180)}else set();
root.querySelectorAll('.card').forEach(function(c){c.classList.toggle('pick',c.dataset.handle===u.handle)});
}
chipsBox.dataset.ready='1';
chipsBox.innerHTML=data.map(function(u,i){return '<button type="button" data-i="'+i+'"'+(i?'':' class="on"')+'>'+u.label+'</button>'}).join('');
chipsBox.addEventListener('click',function(e){
var b=e.target.closest('button');if(!b)return;
chipsBox.querySelectorAll('button').forEach(function(x){x.classList.remove('on')});
b.classList.add('on');
show(+b.dataset.i,true);
});
show(0,false);
}

/* ---------- descrizioni card: troncatura pulita ---------- */
function fitAll(){root.querySelectorAll('[data-full]').forEach(function(el){fit(el,el.dataset.full)})}

function init(){placeSort();initSelector();fitAll();requestAnimationFrame(fitAll)}
init();
window.addEventListener('resize',function(){placeSort();fitAll()});
})();
